export const CREATE_BOUNTY = `
mutation(
  $profileId: ID
  $bountyType: String
  $fullName: String
  $company: String
  $department: String
  $title: String
  $linkedinURL: String
  $demandPrice: Float
  $reason: String
) {
  createBounty(
    input: {
      data: {
        profileId: $profileId
        bountyType: $bountyType
        fullName: $fullName
        company: $company
        department: $department
        title: $title
        linkedinURL: $linkedinURL
        demandPrice: $demandPrice
        reason: $reason
        status: "active"
      }
    }
  ) {
    bounty {
      id
      created_at
    }
  }
}
`;
